export interface SlotMachineSymbol {
  id: number;
  name: string;
  emoji: string;
  points: number;
}

export interface SlotMachineConfig {
  id: number;
  name: string;
  startDate: string;
  endDate: string;
  spinsPerMember: number;
  bonusValidityInDay: number;
  isActive: boolean;
  symbols: SlotMachineSymbol[];
}

export const DUMMY_SLOT_MACHINES: SlotMachineConfig[] = [
  {
    id: 1,
    name: "Summer Jackpot",
    startDate: "2026-06-01",
    endDate: "2026-08-31",
    spinsPerMember: 3,
    bonusValidityInDay: 7,
    isActive: true,
    symbols: [
      { id: 1, name: "Cherry", emoji: "🍒", points: 10 },
      { id: 2, name: "Lemon", emoji: "🍋", points: 20 },
      { id: 3, name: "Diamond", emoji: "💎", points: 100 },
      { id: 4, name: "Seven", emoji: "7️⃣", points: 500 },
      { id: 5, name: "Star", emoji: "⭐", points: 50 },
    ],
  },
  {
    id: 2,
    name: "Weekend Bonus",
    startDate: "2026-05-15",
    endDate: "2026-12-31",
    spinsPerMember: 5,
    bonusValidityInDay: 14,
    isActive: true,
    symbols: [
      { id: 1, name: "Bell", emoji: "🔔", points: 15 },
      { id: 2, name: "Coin", emoji: "🪙", points: 25 },
      { id: 3, name: "Crown", emoji: "👑", points: 200 },
      { id: 4, name: "Gem", emoji: "💠", points: 75 },
      { id: 5, name: "Bar", emoji: "🎰", points: 0 },
    ],
  },
  {
    id: 3,
    name: "Holiday Special",
    startDate: "2026-12-01",
    endDate: "2027-01-15",
    spinsPerMember: 2,
    bonusValidityInDay: 10,
    isActive: false,
    symbols: [
      { id: 1, name: "Gift", emoji: "🎁", points: 30 },
      { id: 2, name: "Tree", emoji: "🎄", points: 40 },
      { id: 3, name: "Snowflake", emoji: "❄️", points: 60 },
      { id: 4, name: "Santa", emoji: "🎅", points: 150 },
      { id: 5, name: "Star", emoji: "⭐", points: 300 },
    ],
  },
];
